import React, { FC, PropsWithChildren } from 'react';
import styles from './TextTag.module.less';

export const TextTag: FC<PropsWithChildren> = (props) => {
  return <div className={styles.textTag}>{props.children}</div>;
};
